import React from 'react';
import { createRoot } from 'react-dom/client';

const services = [
  {
    title: 'Installation',
    body:
      'Installation of control valves, air regulators, filters, solenoids, transmitters, and instrumentation loops with mechanical, electrical, and PLC coordination.'
  },
  {
    title: 'Calibration & Validation',
    body:
      'Traceable calibrations for pressure, flow, temperature, level, vacuum transmitters, RTDs, thermocouples, pH, and conductivity instruments.'
  },
  {
    title: 'Turnkey Projects',
    body:
      'System design, installation, testing, and commissioning for filler, processing, and packaging lines that meet CFIA-ready standards.'
  },
  {
    title: 'Shutdown & Startup Assistance',
    body:
      'Loop checks, CIP verification, pressure tuning, and transition plans so shutdowns and startups happen without surprises.'
  },
  {
    title: 'Repairs',
    body:
      'On-site troubleshooting, diagnostics, and repair of valves, sensors, transmitters, positioners, and control actuators.'
  },
  {
    title: 'Preventative Maintenance',
    body:
      'Scheduled service programs to inspect, test, and maintain instrumentation before failures cause downtime.'
  },
  {
    title: 'Instrumentation Hardware Supply',
    body:
      'Flow meters, pressure instruments, pH/conductivity meters, recorders, indicators, and related hardware stocked for fast deployment.'
  },
  {
    title: 'Digital Transmitters & Sterilization',
    body:
      'Digital transmitter integration and CIP control expertise for HTST, UHT, VISCO, VTIS, and other sterilization systems.'
  },
  {
    title: 'Service Contracts',
    body:
      'Custom programs with routine calibration, preventative maintenance, emergency response, and CFIA compliance support.'
  },
  {
    title: 'Commissioning & Loop Checks',
    body:
      'Pressure tuning, control validation, instrumentation verification, and documentation for CFIA-ready commissioning.'
  },
  {
    title: 'Process Control Support',
    body:
      'PLC coordination, automation loops, and control valve tuning that keep food, beverage, dairy, and pharma plants stable.'
  },
  {
    title: 'CFIA Testing & Compliance',
    body:
      'Holding tube salt tests, inspection plates, pressure trials, and documentation that prove compliance during audits.'
  }
];

const ServiceGrid: React.FC = () => (
  <section className="service-grid-shell" aria-label="Service highlights">
    <div className="service-grid" data-service-grid>
      {services.map((service) => (
        <article className="service-swap-card" key={service.title}>
          <h3>{service.title}</h3>
          <p>{service.body}</p>
        </article>
      ))}
    </div>
  </section>
);

const rootElement = document.getElementById('card-swap-root');
if (rootElement) {
  createRoot(rootElement).render(<ServiceGrid />);
}
